import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { emptyFn } from 'utils/common';
import Enums from 'utils/EnumsManager';
import { FormattedMessage as FM } from 'react-intl';

const { Option } = Select;

const defaultProps = {
  onChange: emptyFn,
  value: null,
  selectedValueError: false,
};
const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      // field name
      name: PropTypes.string.isRequired,
      // field label
      label: PropTypes.string.isRequired,
      // function
      action: PropTypes.oneOf([
        ...Enums.REPORTS.AGGREGATES_ZONE_TAG_ACTIONS,
        'group',
        'count'
      ]),
      // unique, concat name and action, e.g. <name>__<action>
      key: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  selectedValueError: PropTypes.bool,
};

const Dropdown = ({ value, data, onChange, selectedValueError }) => (
  <Select
    onChange={onChange}
    value={value}
    size="small"
    className={`full-width ${selectedValueError ? 'restriction-field' : ''}`}
    dropdownMatchSelectWidth={false}
  >
    {data.map(opt => (
      <Option key={opt} value={opt.key} title={opt.label} disabled={opt.restriction || opt.deleted} className={selectedValueError ? 'restriction-field' : ''}>
        <FM
          id={`page.SlotTable.labels.${opt.action}`}
          values={{ value: opt.label }}
        />
      </Option>
    ))}
  </Select>
);

Dropdown.defaultProps = defaultProps;
Dropdown.propTypes = propTypes;

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});

export default connect(mapStateToProps)(Dropdown);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/UIs/Dropdown.jsx